import {
  ConfigureOptionsParams,
  FilterOptions,
  FilterPassParams
} from '../filter-types';
import { CalendarGridColumnName } from '../../../grid/types/column.types';
import { convertToStringArray } from '../filter-utils';
import { InclusiveExclusiveFilterHandler } from './base/inclusive-exclusive-filter-handler';
import { dealStatusValueGetter } from '../../../grid/utils/value-getters/deal-status';

export class PricingStatusFilterHandler extends InclusiveExclusiveFilterHandler {
  protected getValue(params: FilterPassParams): string[] {
    return [dealStatusValueGetter({ data: params.deal }).pricingStatus];
  }

  get name(): string {
    return CalendarGridColumnName.DealStatus;
  }

  configureFilterOptions(params: ConfigureOptionsParams): void {
    params.setFilterService.pricingStatuses =
      params.filterOptions.pricingStatuses;
  }

  getFilterOptions(filterOptions: FilterOptions): any {
    return convertToStringArray(filterOptions.pricingStatuses);
  }
}
